export default {
  riskMap: "Mapa de riesgos"
}
